export default {
      id: "ic-para-location-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-para-location-usage",
      toString: function () {
        return this.url;
      }
    }